
const BASE_URL = `${window.location.origin}`
const BASE_PATH = `${window.location.pathname}`

export const getMetaTags = () => {

	const dealer = BASE_URL.includes('charleshurst') ? "Charles Hurst" : "Lookers"
	const metaTitle = document.getElementsByTagName('meta')['title'  as unknown as number];
	const metaDescription = document.getElementsByTagName('meta')['description'  as unknown as number];
	const canonical = document.querySelectorAll("link[rel='canonical']")[0]; 
	const favicon = document.querySelectorAll("link[rel='icon']")[0];   

	if (metaTitle && metaDescription && canonical) {
		favicon.setAttribute("href", `${BASE_URL.includes('charleshurst') ? `${BASE_PATH}/favicon-Charleshurst-32x32.png` : `${BASE_PATH}/favicon-32x32.png`}`)
		document.title = `Sell Your Vehicle to ${dealer} with Click and Sell`;
		canonical.setAttribute("href", `https://www.${BASE_URL.includes('charleshurst') ? 'charleshurstgroup' : 'lookers'}.co.uk/click-and-sell/`);
		metaTitle.content = `Click and Sell | Accurate Vehicle Valuation Tool | ${dealer}`;
		metaDescription.content = `Sell your vehicle today! Use the free ${dealer} Click and Sell vehicle valuation tool for an instant and accurate vehicle valuation.`;
	}
}